// P1 meter entity identity + health thresholds (age = now - row.ems)
export const P1_RK = 'p1';
export const P1_TYPE = 'P1Meter';
export const P1_STALE_MS = 5000;
export const P1_OFFLINE_MS = 30000;
